(function(){
  /* Carousel */
  var track=document.getElementById('jvCarouselTrack');
  var thumbs=document.querySelectorAll('#jv-lander .jv-carousel-thumb');
  var cur=0,cnt=track.children.length;

  function goTo(i){
    cur=i;
    track.children[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(+this.dataset.slide)})});

  var st;
  track.addEventListener('scroll',function(){
    clearTimeout(st);
    st=setTimeout(function(){
      var i=Math.round(track.scrollLeft/track.offsetWidth);
      if(i!==cur&&i>=0&&i<cnt){
        cur=i;
        thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
      }
    },80);
  },{passive:true});

  /* Single offer - no tier selection */
  var variantId=43533787103310;
  var sellingPlan=2655420494;
  var qty=1;
  var shakerVariantId=41679873769550;
  var mixerVariantId=42933942616142;
  var discountCode='LTO-CREATINESTICK';
  var giftDiscountCode='FREESTARTERKIT';
  var ctaDefault='Try Jive \u2014 $27';

  /* Loading messages for ATC */
  var loadingSteps=[
    'Checking availability',
    'Reserving your order',
    'Applying discount',
    'Redirecting to checkout'
  ];

  function runLoadingSequence(btns,stickyTextEl){
    var stepIndex=0;
    var currentInterval=null;
    var spans=[];
    btns.forEach(function(b){
      var sp=b.querySelector('span');
      if(sp) spans.push(sp);
    });
    if(stickyTextEl) spans.push(stickyTextEl);

    function showStep(){
      if(stepIndex>=loadingSteps.length){
        if(currentInterval) clearInterval(currentInterval);
        if(onDone) onDone();
        return;
      }
      var msg=loadingSteps[stepIndex];
      if(currentInterval) clearInterval(currentInterval);
      var dots=0;
      currentInterval=setInterval(function(){
        dots=(dots%3)+1;
        var txt=msg+Array(dots+1).join('.');
        spans.forEach(function(sp){sp.textContent=txt});
      },400);
      spans.forEach(function(sp){sp.textContent=msg+'.'});
    }

    showStep();
    return {
      next:function(){
        stepIndex++;
        showStep();
      },
      finish:function(){
        if(currentInterval) clearInterval(currentInterval);
      }
    };
  }

  /* ATC - clear cart, add with selling plan, redirect to checkout */
  window.jvHandleAddToCart=function(){
    var btns=document.querySelectorAll('#jv-lander .jv-btn-cta');
    var stickyText=document.getElementById('jvCtaStickyText');
    btns.forEach(function(b){b.style.opacity='.85';b.style.pointerEvents='none'});
    if(stickyText) stickyText.style.pointerEvents='none';

    var seq=runLoadingSequence(btns,stickyText);

    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      seq.next();
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[
          {id:variantId,quantity:qty,selling_plan:sellingPlan},
          {id:shakerVariantId,quantity:1},
          {id:mixerVariantId,quantity:1}
        ]})
      });
    })
    .then(function(r){if(!r.ok)throw new Error('Cart error');return r.json()})
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,800)});
    })
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,600)});
    })
    .then(function(){
      seq.finish();
      window.location.href='/checkout?discount='+discountCode+'&discount='+giftDiscountCode;
    })
    .catch(function(e){
      console.error(e);
      seq.finish();
      btns.forEach(function(b){
        b.style.opacity='';b.style.pointerEvents='';
        var sp=b.querySelector('span');
        if(sp) sp.textContent=ctaDefault;
      });
    });
  };

  /* Sticky */
  var bar=document.getElementById('jvStickyBar'),info=document.querySelector('#jv-lander .jv-product-info');
  function onScroll(){bar.classList.toggle('jv-visible',info.getBoundingClientRect().bottom<0)}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* Detail panels accordion (product info dropdowns) */
  document.querySelectorAll('#jv-lander .jv-detail-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-detail-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('#jv-lander .jv-faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-faq-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* Lucide */
  if(window.lucide){lucide.createIcons();}
})();
